import { LoaderFunctionArgs, redirect } from "react-router";

export default async function entityAdministrationLoader(args: LoaderFunctionArgs) {
  const routeParams = args.params;
  if (!routeParams) return redirect("/administration/users");
  return routeParams;
}
